/* eslint-disable camelcase */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { dataPropTypes, fieldsPropTypes, errorsPropTypes } from '../propTypes';
import { tableHooks, TableControls } from '../../../../../basicEditor/tableControls';
import TabelRowCell from '../../../../../newEditor/tablePart/tabkeRowCell';

function TRow({
  rowIndex,
  onChange,
  row,
  fields,
  errors,
  highlights,
  readOnly,
  readOnlyFields,
}) {
  const gas_equpmanet = tableHooks.useSelectorInputProps('gas_equpmanet', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);
  const amount = tableHooks.useNumberInputProps('amount', row, fields, errors, onChange, rowIndex, readOnly, readOnlyFields);

  return (
    <Row className="px-1 d-flex">
      <Col xl={8} lg={8}>
        <TabelRowCell
          column="gas_equpmanet"
          highlighted={highlights.includes('gas_equpmanet')}
        >
          <TableControls.SelectorInput {...gas_equpmanet} />
        </TabelRowCell>
      </Col>
      <Col xl={4} lg={4} className="px-1">
        <TabelRowCell
          column="amount"
          highlighted={highlights.includes('amount')}
        >
          <TableControls.NumberInput
            {...amount}
            precision={0}
          />
        </TabelRowCell>
      </Col>
    </Row>
  );
}

TRow.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  row: PropTypes.shape(dataPropTypes).isRequired,
  errors: errorsPropTypes,
  onChange: PropTypes.func.isRequired,
  readOnlyFields: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool,
  fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string),
  onToggleHighlight: PropTypes.func.isRequired,

};

TRow.defaultProps = {
  errors: null,
  readOnlyFields: [],
  readOnly: false,
  activeCol: null,
  highlights: [],
};

export default memo(TRow);
